export const background = new URL(BACKGROUND_URL, import.meta.url).href;

export const logo = new URL(LOGO_URL, import.meta.url).href;
export const logoLong = new URL(LOGO_LONG_URL, import.meta.url).href;
